import * as React from 'react';
import '../../_assets/css/file.css';
import axios from 'axios';
import { baseURL } from '../../_helpers';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';

export default class OnlineNotifications extends React.Component {

    constructor(props) {
        super(props)


        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            phone_number: '',
            showError: false
        }
    }





    componentDidMount() {
        this.getData();
    }

    getData = (queryString = "") => {
        this.setState({
            isLoading: true,
        })
        let url = baseURL + "notifications?" + queryString
        console.log("query", url);

        axios.all([
            axios.get(url)
        ]).then(axios.spread((branchResponse) => {
            this.setState({
                admins: branchResponse.data.data,
                notifications_1st_instance: branchResponse.data.data[0].notifications_1st_instance,
                notifications_2nd_instance: branchResponse.data.data[0].notifications_2nd_instance,
                id: branchResponse.data.data[0].id,
                isLoading: false,
            },
                function () {
                    var data = [];
                   
                }
            );
        }))

    }


    onSubmit(e) {
        e.preventDefault();

        let formData = {
            "notifications_1st_instance": this.state.notifications_1st_instance,
            "notifications_2nd_instance": this.state.notifications_2nd_instance,
            "id": this.state.id

        }
        console.log("DATA", JSON.stringify(formData))
        this.setState({ isLoading: true });

        axios.put(baseURL + 'notifications', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        })
            .then((response) => {
                console.log("bayo", response)
                // eslint-disable-next-line
                if (response.data.success == true) {
                    console.log("records", formData)

                    this.setState({ statusMessage: response.data.message, isShowError: true, isLoading: false });

                    setTimeout(() => {
                        this.setState({ statusMessage: "", isShowError: false, isLoading: false });
                    }, 2000);

                } else {

                    this.setState({ statusMessage: response.data.message, isShowError: true, isLoading: false });
                }

            })
            .catch(error => {
                console.log('bayoo', error.response)
                this.setState({
                    showError: true,
                    isShowError: false,
                    statusMessage: error.response.data.message,
                    submitted: true,
                    isLoading: false
                }
                    , function () {
                        // console.log('data', error.response.status_message)
                    });
            });

    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    render() {
        const { showComponent } = this.state;
        const { hideComponent } = this.state;

        return (
            <div className="pcoded-main-container">

                {showComponent && (
                    <div>

                        {this.state.showComponent ?
                            <peopleView /> : null
                        }

                    </div>
                )}

                {!hideComponent && (
                    <>
                        <Col md={12}>
                            <h4>Edit Online Game Notifications</h4><br />
                        </Col>
                        <Col md={12} lg={12}>
                            <Card>
                                <CardBody>

                                    {/* {this.state.showError ? <div style={{ color: 'red' }}>
                                        {this.state.statusMessage}

                                    </div> : null}<br></br> */}

                                    {this.state.isShowError ? (
                                        <div
                                            color="success"
                                            style={{ fontSize: "13px", color: "green" }}>
                                            {this.state.statusMessage}
                                        </div>

                                    ) : null}<br></br>
                                    <form className="col-md-8 offset-md-2" onSubmit={this.onSubmit}>

                                        <div className="form-group">
                                            <input id="input" type="text" className="form-control input-md"
                                                name="notifications_1st_instance" placeholder="Enter Phone Number"
                                                value={this.state.notifications_1st_instance} onChange={this.handleChange} />
                                            <br />
                                            <input id="input" type="text" className="form-control input-md"
                                                name="notifications_2nd_instance" placeholder="Enter Phone Number"
                                                value={this.state.notifications_2nd_instance} onChange={this.handleChange} />

                                        </div>
                                        <br />
                                        <div className="col-md-12">
                                            <Button type="submit" color="primary" outline className="btn-paypal btn-lg pull-right
                                                                    " >
                                                {this.state.isLoading ? "Please Wait..." : "Submit"}  <i className="fa fa-refresh"></i></Button> &nbsp;&nbsp;&nbsp;
                                        </div>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                    </>

                )
                }

            </div>
        )

    }

}
